// 组件类
import {
  AfterViewInit,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { TabComponent } from "@syncfusion/ej2-angular-navigations";

@Component({
  selector: "rs-page-tab",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RsPageTabComponent implements OnInit, AfterViewInit {
  @ViewChild("tabObj", { static: false })
  public tabObj: TabComponent;
  @Input() pageTitle;
  @Input() customPageTitle = false;
  @Input() tabList = [];
  @Input() currentTab;

  @Output()
  tabChange = new EventEmitter();
  selectedItemIndex = 0;

  public animation: object = {
    previous: { effect: "", duration: 0, easing: "" },
    next: { effect: "", duration: 0, easing: "" },
  };
  ngOnInit() {}

  ngAfterViewInit(): void {
    if (this.currentTab !== undefined) {
      const idx = this.tabList.findIndex(
        (ele) => ele.value === this.currentTab
      );
      setTimeout(() => {
        this.tabObj.select(idx);
      }, 30);
    }
  }
  onTabClick(e) {
    const index = e.selectedItem.dataset.id.split('_')[1] // sy的bug只能这么取了
    if (e.isInteracted) {
      this.selectedItemIndex = index;
      this.tabChange.emit(this.tabList[index]);
    }
  }
  // 切换tab,传入下标
  changeTab(idx: number) {
    this.tabObj.select(idx);
  }
}
